import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const StockList = WithErrorBoundary(
  'Stock',
  'Error en Lista de Stock por catálogo',
  React.lazy(() => import('./StockList')),
)

const FormularioStock = WithErrorBoundary(
  'Stock',
  'Error en Formulario de Stock',
  React.lazy(() => import('./FormularioStock')),
)

const StockMain = WithErrorBoundary(
  'Stock',
  'Error en Lista de Stock',
  React.lazy(() => import('./StockMain')),
)

const MassiveStockUploadStore = WithErrorBoundary(
  'Stock',
  'Error en Carga Masiva de Stock',
  React.lazy(() => import('./massive-upload/MassiveStockUpload.store')),
)

const DictionaryStore = WithErrorBoundary(
  'Stock',
  'Error en Diccionario de stock',
  React.lazy(() => import('./dictionary/Dictionary.store')),
)

const TakingCarManagementStore = WithErrorBoundary(
  'Stock',
  'Error en Taking car Management de stock',
  React.lazy(() => import('./taking-car-management/TakingCarManagement.store')),
)

const FastStockLoadingStore = WithErrorBoundary(
  'Stock',
  'Error en Carga Rápida de usados',
  React.lazy(() => import('./taking-car-management/FastStockLoading/FastStockLoading.store')),
)

export default {
  path: '/stock',
  name: 'Stock',
  childRoutes: [
    { path: 'stock-main', name: 'Stock main', component: StockMain, isIndex: true },
    { path: 'carga-masiva', name: 'Carga Masiva ', component: MassiveStockUploadStore},
    { path: 'carga-masiva/diccionario', name: 'Diccionario ', component: DictionaryStore},
    { path: 'gestion-de-usados', name: 'Gestión de usados', component: TakingCarManagementStore, location: '' },
    { path: 'gestion-de-usados/carga-rapida-usados', name: 'Carga rápida de usados', component: FastStockLoadingStore},
    
    { path: ':id', name: 'Stock list', component: StockList },
    { path: ':id/editar/:idStock', name: 'Stock edit', component: FormularioStock },
    { path: ':id/crear', name: 'Stock edit', component: FormularioStock },

  ],
}
